
import {
  TOGGLE_SHOW_MORE_ACTIVITY,
  SET_ACTIVITY_FILTER,
  SET_ACTIVITY_SEARCH_TERM,
  RECEIVE_ACTIVITY
} from 'actions'

const initialState = {
  isShowingMoreActivity: false,
  filter: '',
  search: '',
  hasActivity: false,
  didReceiveActivity: false
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case TOGGLE_SHOW_MORE_ACTIVITY:
      return {
        ...state,
        isShowingMoreActivity: !state.isShowingMoreActivity
      }
    case SET_ACTIVITY_FILTER:
      return {
        ...state,
        filter: payload
      }
    case SET_ACTIVITY_SEARCH_TERM:
      return {
        ...state,
        search: payload
      }
    case RECEIVE_ACTIVITY:
      return {
        ...state,
        didReceiveActivity: true,
        hasActivity: payload.response.length > 0
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/application/workspace-activity.js